import React from 'react'

import {FieldEditableValueNotEmptyProps} from "../../../../../proto/components/editable/value-not-empty"
import ControlButtonStandard from "../../../../../../gd-components/buttons/control-button/control-button-standard"
import {ControlButtonSize} from "../../../../../../gd-components/buttons/control-button/@types"

// const debug = "FieldSelectField_ControlViewEmpty"
const debug = false

export default function FieldSelectField_ControlViewEmpty(props:FieldEditableValueNotEmptyProps) {

    const classes = Classes("p-l-6 p-r-6", props.className)

    debug && console.log(debug, 'render', props.field.placeholder, props)

    return (
        <ControlButtonStandard
            className       = {classes}
            size            = {ControlButtonSize.SIZE_28}
            selectedClass   = "hover-bg"
            isSelected      = {true}
            isDisabled      = {props.disabled}
            onClick         = {props.onClick}>
            {_.get(props.field.components, 'ValueIcon', false)}

            <div className="label txt-truncate ui5-txt-not-important-small">
                {props.field.placeholder}
            </div>

            {props.children}
        </ControlButtonStandard>
    )

}

